module.exports = __webpack_public_path__ + "img/1047163.4a7b36b6.png";